import { render, staticRenderFns } from "./MobileWallet.vue?vue&type=template&id=51529858&"
import script from "./MobileWallet.vue?vue&type=script&lang=js&"
export * from "./MobileWallet.vue?vue&type=script&lang=js&"
import style0 from "./MobileWallet.vue?vue&type=style&index=0&id=51529858&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports